import { getIsAdvanceOauthApp, isExternalDashboardApp } from '../selectors/appRuntimeReader';
export const getShouldOpenNewWindow = (app, avoidPostInstallation) => getIsAdvanceOauthApp(app) || !avoidPostInstallation && isExternalDashboardApp(app);
//# sourceMappingURL=get-should-open-new-window.js.map